import SendConnectionModal from './SendConnectionModal'

export default SendConnectionModal
